// extracted by mini-css-extract-plugin
module.exports = {"accordion":"styles_accordion__oC5CJ","sidebar":"styles_sidebar__SnctL","content":"styles_content__Vufwi","gradient":"styles_gradient__ckMCc"};